import React from 'react'
import {push} from 'connected-react-router'
import {connect} from 'react-redux'

import {store} from '../../helpers'

export class About extends React.Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    event.preventDefault()
    const {dispatch} = store

    dispatch(push('/signup'))
  }

  render() {

    return (
      <div>
        <div className="container mb-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-9 col-sm-12">
                  <h2 className="heading mb-5">
                    an
                    <span className="text-primary">
                      {" introduction"}
                    </span>
                  </h2>
                </div>
              </div>
              <h5 className="mb-4">
                Dance Injuries Study
              </h5>
              <p className="text-justify mb-5">
                Thank you for your important contribution through participation in this dance injury study. A lot of
                children and youth take dance classes and it is common to get injured in these dance classes. A dance
                injury will keep you from dancing and being active, which can change how healthy you are. Research is
                important to help understand how to keep these injuries in dance from happening. It helps us understand
                how many are dancing, how many injuries there are, what makes the chances of getting injured higher and
                what people can do to lower the chances of getting hurt right now. This will help researchers come up
                with ways to stop injuries from happening in the future.
                <br/>
                <br/>
              </p>
              <h5 className="mb-4">
                ETHICS APPROVAL
              </h5>

              <p className="mb-5 text-justify">
                This study has been approved by the Research Ethics Board at the University of Calgary (REB14-0897/ REBB 22-1365) and the Wake Forest University Institutional Review Board (IRB-00089998).
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  const {isAuthenticated} = state.session

  return {
    isAuthenticated,
  }
}

export default connect(mapStateToProps)(About)
